import React, { useEffect, useLayoutEffect, forwardRef, useState } from "react";
import SendPackageStyle from "./SendPackageStyle";
import { withStyles } from "@material-ui/core/styles";
import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Allservices from "../../Allservices";
import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SwitchUnstyled, {
  switchUnstyledClasses,
} from "@mui/base/SwitchUnstyled";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import clsx from "clsx";
import moment from "moment";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import Checkbox from "@mui/material/Checkbox";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import axios from "axios";
import Paper from "@mui/material/Paper";
import { v4 as uuidv4 } from "uuid";
import MenuList from "@mui/material/MenuList";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@mui/icons-material/Check";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useNavigate } from "react-router-dom";
//import ScheduleLater from "./ScheduleLater";

import Footer from "../../../Homepage/Footer";
import DatePicker from "react-datepicker";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import Configuration from "../../../config.json";
import { getBaseURL } from "../../../../api/apiManagement";
import Select from "@mui/material/Select";
import PhotoScheduleLater from "./PhotoScheduleLater";

const blue = {
  50: "#131C4C",
  100: "#C2E0FF",
  200: "#FFFFFF",
  300: "#66B2FF",
  400: "#EBE3CA",
  500: "#EBE3CA",
  600: "#FFFFFF",
  700: "#0059B2",
  800: "#004C99",
  900: "#003A75",
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: #131c4c;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  height: 120px;
  border-radius: 60px;
  &:hover {
    background-color: ${blue[400]};
  }

  &:focus {
    color: #fff;
    font-weight: 700;
    border-radius: 60px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${blue[50]};
    color: ${blue[600]};
    border-radius: 60px;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
    border-radius: 60px;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 320px;
  background-color: ${blue[500]};
  border-radius: 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 60px;
`;

const green = {
  500: "#000000",
};

const grey = {
  400: "#BFC7CF",
  500: "#AAB4BE",
  600: "#6F7E8C",
};
const names = [
  { value: "Online e-Visa", size: "43x55mm" },
  { value: "Visa", size: "43x55mm" },
  { value: "Passport", size: "40x54mm" },
  { value: "ID Card", size: "40x60mm" },
];
const Root = styled("span")(
  ({ theme }) => `
    font-size: 0;
    position: relative;
    display: inline-block;
    width: 75px;
    height: 35px;
    margin: 0px 15px;
    cursor: pointer;
    margin-top: 10px;
  
    &.${switchUnstyledClasses.disabled} {
      opacity: 0.4;
      cursor: not-allowed;
    }
  
    & .${switchUnstyledClasses.track} {
      background: ${theme.palette.mode === "dark" ? grey[600] : grey[400]};
      border-radius: 29px;
      display: block;
      height: 35px;
      width: 75px;
      position: absolute;
    }
  
    & .${switchUnstyledClasses.thumb} {
      display: block;
      width: 29px;
      height: 29px;
      top: 3px;
      left: 5px;
      border-radius: 16px;
      background-color: #fff;
      position: relative;
      transition: all 200ms ease;
    }
  
    &.${switchUnstyledClasses.focusVisible} .${switchUnstyledClasses.thumb} {
      background-color: ${grey[500]};
      box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);
    }
  
    &.${switchUnstyledClasses.checked} {
      .${switchUnstyledClasses.thumb} {
        left: 41px;
        top: 3px;
        background-color: #fff;
      }
  
      .${switchUnstyledClasses.track} {
        background: #131C4C;
      }
    }
  
    & .${switchUnstyledClasses.input} {
      cursor: inherit;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 1;
      margin: 0;
    }
    `
);

/*Drop DOWN Info */

const PhotoService = (props) => {
  const url = getBaseURL() + "/vendor/api/v1/photoservice";

  const priceUrl = getBaseURL() + "/vendor/api/v1/photoprice";

  const { classes } = props;
  const navigate = useNavigate();
  const [alignmentPickup, setAlignmentPickup] = React.useState("AM");
  const [alignment, setAlignment] = React.useState("AM");
  const [alignmentTrans, setAlignmentTransport] = React.useState("car");
  const [error1, setError1] = React.useState(false);
  const [error2, setError2] = React.useState(false);
  const [error3, setError3] = React.useState(false);
  const [error4, setError4] = React.useState(false);
  const [error5, setError5] = React.useState(false);
  const [error6, setError6] = React.useState(false);
  const [error7, setError7] = React.useState(false);
  const [error8, setError8] = React.useState(false);
  const [error9, setError9] = React.useState(false);
  const [error10, setError10] = React.useState(false);
  const [errorImg, setErrorImg] = React.useState(false);
  const [errorName, setErrorName] = React.useState(false);
  const [errorName1, setErrorName1] = React.useState(false);
  const [id, setId] = React.useState(0);
  const [pickupPrice, setPickupPrice] = React.useState();
  const [frMsg, setFrMsg] = React.useState("");
  const [friday, setFriday] = React.useState(false);
  const handleFriday = () => {
    setFriday(false);
  };
  const [openClause, setClause] = React.useState(false);
  const handleCloseClause = () => {
    setClause(false);
  };
  const clause = () => {
    setClause(true);
  };


  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: 6,
      }}
    />
  );
  const [openError, setOpenError] = React.useState(false);
  const [openErrorQuan, setOpenErrorQuan] = React.useState(false);
  const [openBag, setBag] = React.useState(false);
  const handleBag = () => {
    setBag(false);
  };
  const [openDocError, setDocError] = React.useState(false);
  function handleCloseErrorDoc() {
    setDocError(false);
  }
  function handleCloseErrorQuan() {
    setOpenErrorQuan(false);
  }
  const [openLoc, setLoc] = React.useState(false);
  function handleCloseLoc() {
    setLoc(false);
  }
  function handleCloseError() {
    setOpenError(false);
  }
  const [prefer, setPrefer] = React.useState(false);
  const [preferIcon, setPreferIcon] = React.useState("black");
  function handleClosePrefer() {
    setPrefer(false);
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    bgcolor: "background.paper",
    border: "2px solid #fff",
    boxShadow: 24,
    p: 4,
    borderRadius: "10px",
    height: "500px",
    overflowX: "scroll",
    "@media (max-width: 600px)": {
      width: 350,
      top: "50%",
      left: "250%",
    },
  };
   const [openOrderPlaced, setorder] = React.useState(false);
    const handleCloseOrderPlaced = () =>{
      setorder(false)
    }
    const navigateToOrders = () => {
      navigate("/allorders");
    }
  const handleSubmitPhoto = (event) => {
    event.preventDefault();
    if(!address || coordinate.lat === ''){
      setError1(true)
    }
    else{
      setError1(false)
    }
    if(!phone){
      setError2(true)
    }
    else{
      setError2(false)
    }
    if(!email){
      setError3(true)
    }
    else{
      setError3(false)
    }
    if(!pickup){
      setError4(true)
    }
    else{
      setError4(false)
    }
    if(!photoName.length){
      setError5(true)
    }
    else{
      setError5(false)
    }
   
  
    if(!personName){
      setError6(true)
    }
    else{
      setError6(false)
    }
    if(!descript){
      setError7(true)
    }
    else{
      setError7(false)
    }
    if(address && coordinate.lat !== '' && phone && email && pickup  && photoName.length && descript && !errorImg){
      setLoaded("Loading...");
      let params = {
      place: address,
      phone_number: phone,
      user_email_address: email,
      pick_up_time: moment(pickup).format("hh:mm"),
      am_or_pm: alignmentPickup,
      name: photoName?.[0]?.name,
      nameInDetail:photoName,
      photo_specification: personName,
      instruction: descript,
      price: price,
      immigoCaseNumber: imigo,
      order_status: "Pending",
      user_id: localStorage.getItem("userId"),
      pickupDate: new Date()
    };
    axios.post(url, params).then((res) => {
      console.log(res.data);
      // postId = res.data
      if (res.data.status === "Success") {
        setorder(true)
        // navigate("/allorders");
        // postId = res.data.id
        //setId(res.data.id);
        //  console.log(id);
      }
      try {
      } catch (error) {
        console.error();
      }
    });
  }
  };

  const gotoTracker = () => {
    axios.get(url + "?" + id).then((response) => {
      console.log(JSON.stringify(response));
    });
  };
  const [clear, getClear] = React.useState(false);
  const clearDetails = () => {
    getClear(true);
    getArrow(false);
    setPhone1("");
    setemail1("");
    setPickup1("");
    setdesc1("");
    setAddress1("");
    setPhone2("");
    setemail2("");
    setPickup2("");
    setdesc2("");
    setAddress2("");
  };
  const [plus, getPlus] = React.useState(false);
  const [phone, setPhone] = React.useState(null);
  const [email, setemail] = React.useState(null);
  const [time, setTime] = React.useState(null);
  const [pickup, setPickup] = React.useState(null);

  const [descript, setdesc] = React.useState(null);
  const pickupPhone = (val) => {
    setPhone(val.target.value);
  };
  const pickupEmail = (val) => {
    setemail(val.target.value);
  };
  const pickupDesc = (val) => {
    setdesc(val.target.value);
  };
  const [pickupName, setPickupName] = React.useState(null);
  const [pickupName1, setPickupName1] = React.useState(null);
  const [pickupName2, setPickupName2] = React.useState(null);
  const [pickupNameD, setPickupNameD] = React.useState(null);
  const pickupNameSet = (event,val) => {
    //setPickupName(val.target.value);
    photoName[val].name = event.target.value;
  };
  const pickupNameSet1 = (val) => {
    setPickupName1(val.target.value);
  };
  const pickupNameSet2 = (val) => {
    setPickupName2(val.target.value);
  };
  const pickupNameSetD = (val) => {
    setPickupNameD(val.target.value);
  };
  const addPlus = () => {
    getPlus(!plus);
  };
  const [phone1, setPhone1] = React.useState(null);
  const [email1, setemail1] = React.useState(null);
  const [time1, setTime1] = React.useState(null);
  const [pickup1, setPickup1] = React.useState(null);
  const [descript1, setdesc1] = React.useState(null);
  const pickupPhone1 = (val) => {
    setPhone1(val.target.value);
  };
  const pickupEmail1 = (val) => {
    setemail1(val.target.value);
  };
  const pickupDesc1 = (val) => {
    setdesc1(val.target.value);
  };

  const [phone2, setPhone2] = React.useState(null);
  const [email2, setemail2] = React.useState(null);
  const [time2, setTime2] = React.useState(null);
  const [pickup2, setPickup2] = React.useState(null);
  const [descript2, setdesc2] = React.useState(null);

  const [phoneD, setPhoneD] = React.useState(null);
  const [emailD, setemailD] = React.useState(null);
  const [timeD, setTimeD] = React.useState(null);
  const [imigo, setImigo] = React.useState(null);

  const [descriptD, setdescD] = React.useState(null);
  const phoneDel = (val) => {
    setPhoneD(val.target.value);
  };
  const emailDel = (val) => {
    setemailD(val.target.value);
  };
  const descDel = (val) => {
    setdescD(val.target.value);
  };
  const ImgNumber = (val) => {
    const inputValue = val.target.value;
    const numericValue = inputValue.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    val.target.value = numericValue;
    setImigo(val.target.value);
    if(val.target.value.length >= 6){
      setErrorImg(false);
    }
    else{
      setErrorImg(true);
    }
  };

  const [arrow, getArrow] = React.useState(false);
  const [address, setAddress] = React.useState(null);
  const [address1, setAddress1] = React.useState(null);
  const [address2, setAddress2] = React.useState(null);
  const [price, setPrice] = React.useState("0");
  const [priceBack, setPriceBack] = React.useState("0");
  const [dprice, setPriceD] = React.useState("");
  const [addressDelivery, setAddressDelivery] = React.useState(null);
  const [addressStop, setAddressStop] = React.useState(null);
  const [coordinate, setCoordinates] = React.useState({ lat: "", long: "" });
  const [coordinate1, setCoordinates1] = React.useState({ lat: "", long: "" });
  const [coordinate2, setCoordinates2] = React.useState({ lat: "", long: "" });
  const [coordinateDelivery, setCoordinatesDelivery] = React.useState({
    latDel: "",
    longDel: "",
  });
  const [coordinateStop, setCoordinatesStop] = React.useState({
    latStop: "",
    longStop: "",
  });
  const [activeTab, setActiveTab] = React.useState(1);

  const handleChanged = (address) => {
    //this.setState({ address });
  };
  const getArrowDown = () => {
    getArrow(!arrow);
    getClear(false);
  };
  const handleSelect = async (value) => {
    const result = await geocodeByAddress(value);
    console.log(JSON.stringify(result));
    const ll = await getLatLng(result[0]);
    setAddress(value);
    setCoordinates(ll);
    console.log(JSON.stringify(ll));
    // geocodeByAddress(address)
    //    .then(results => getLatLng(results[0]))
    //    .then(latLng => console.log('Success', latLng))
    //   .catch(error => console.error('Error', error));
    let params = {
      user_id: localStorage.getItem("userId"),
      location: value,
      type_photo: personName,
      photo_lat:  String(ll.lat),
      photo_lng:  String(ll.lng)

    };
    axios.post(priceUrl, params).then((res) => {
      console.log("PRICEEEEEEE", res.data);
      setPrice(res.data.estimatedPrice);
      setPriceBack(res.data.estimatedPrice);
      try {
      } catch (error) {
        console.error();
      }
    });
  };
  const callPriceParamsPhotoService = async (val) => {
    let params = {
      user_id: localStorage.getItem("userId"),
      location: address,
      type_photo: personName,
      photo_lat: String(coordinate.lat),
      photo_lng: String(coordinate.lng)
    };
    axios.post(priceUrl, params).then((res) => {
      console.log("PRICEEEEEEE", res.data);
      setPrice(res.data.estimatedPrice);
      setPriceBack(res.data.estimatedPrice);
      try {
      } catch (error) {
        console.error();
      }
    });
  };

  const callPriceParams = async (val) => {
    let p = [];
    let pDetails = {};
    pDetails["id"] = "1";
    pDetails["pickup_location"] = address;
    pDetails["pickup_location_phone"] = phone;
    pDetails["pickupEmail"] = email;
    pDetails["pickupTime"] = pickup;
    pDetails["pickupTimeDesc"] = alignment;
    pDetails["pickup_instruction"] = descript;
    pDetails["pickup_latitude"] = String(coordinate.lat);
    pDetails["pickup_longitude"] = String(coordinate.lng);
    pDetails["pickup_status"] = "pending";

    let pDetails1 = {};
    pDetails1["id"] = "2";
    pDetails1["pickup_location"] = address1;
    pDetails1["pickup_location_phone"] = phone1;
    pDetails1["pickupEmail"] = email1;
    pDetails1["pickupTime"] = pickup1;
    pDetails1["pickupTimeDesc"] = alignment;
    pDetails1["pickup_instruction"] = descript1;
    pDetails1["pickup_latitude"] = String(coordinate1.lat);
    pDetails1["pickup_longitude"] = String(coordinate1.lng);
    pDetails1["pickup_status"] = "pending";

    let pDetails2 = {};
    pDetails2["id"] = "3";
    pDetails2["pickup_location"] = address2;
    pDetails2["pickup_location_phone"] = phone2;
    pDetails2["pickupEmail"] = email2;
    pDetails2["pickupTime"] = pickup2;
    pDetails2["pickupTimeDesc"] = alignment;
    pDetails2["pickup_instruction"] = descript2;
    pDetails2["pickup_latitude"] = String(coordinate2.lat);
    pDetails2["pickup_longitude"] = String(coordinate2.lng);
    pDetails2["pickup_status"] = "pending";

    p.push(pDetails);
    if (address1 !== null) {
      p.push(pDetails1);
    }
    if (address2 !== null) {
      p.push(pDetails2);
    }

    let priceParams = {};
    priceParams["pickup_latitude"] = String(coordinate.lat);
    priceParams["pickup_longitude"] = String(coordinate.lng);
    priceParams["delivery_latitude"] = String(coordinateDelivery.lat);
    priceParams["delivery_longitude"] = String(coordinateDelivery.lng);
    priceParams["delivery_type"] = "delivernow";
    priceParams["no_of_pickup"] = p.length;
    priceParams["pickup"] = p;
    priceParams["userId"] = localStorage.getItem("userId");
    priceParams["company_id"] = localStorage.getItem("companyId");
    priceParams["transport_type"] = val;
    console.log(priceParams);
    // if (coordinate.lat|| coordinate.lng || ll.lat || ll.lng) {
    axios.post(priceUrl, priceParams).then((res) => {
      console.log("PRICEEEEEEE", res.data);
      setPrice(res.data.estimatedPrice);
      setPriceD(res.data.deliveryPartnerPrice);

      try {
      } catch (error) {
        console.error();
      }
    });
  };

  const [inputFields, setInputFields] = React.useState([]);
  const [inputFieldsCompany, setInputFieldsCompany] = React.useState([]);
  const [inputFieldsPhoto, setInputFieldsPhoto] = React.useState([]);
  const [inputFieldsMcerti, setInputFieldsMcerti] = React.useState([]);
  const [inputFieldsBcerti, setInputFieldsBcerti] = React.useState([]);
  const [inputFieldsDcerti, setInputFieldsDcerti] = React.useState([]);
  const [inputFieldsOther, setInputFieldsOther] = React.useState([]);

  const [drop, setDrop] = React.useState(null);
  const [mode, setMode] = React.useState("bike");

  const [openA3, setA3] = React.useState(false);
  const setPreferA3 = () => {
    setA3(true);
  };
  const handleCloseA3 = () => {
    setA3(false);
  };

  const [quanBlack, setquanBlack] = React.useState(1);
  const [photoQuan, setPhotoQuan] = React.useState(1);
  const [quanWhite, setquanWhite] = React.useState(1);
  const [quanA3, setquanA3] = React.useState(1);
  const [photoName,setPhotoName]=React.useState([{ name: "" }]);
  const addPhotoQuan = () => {
    if(photoQuan+1 <= 3){
    setPhotoQuan(photoQuan + 1);
    setPhotoName([...photoName, { name: "" }]);
    setPrice(price + priceBack);
    }
    else{
      setOpenErrorQuan(true);
    }

  };
  const removePhotoQuan = () => {
   if(photoQuan !== 1){
    setPhotoQuan(photoQuan - 1);
    const values = [...photoName];
   values.pop();
   setPhotoName(values);
   setPrice(price-priceBack);
   }
   
  };
  const [loaded, setLoaded] = React.useState("Submit Order");
  const [loading, setLoading] = React.useState(true);
  function handleClick6() {
    setLoading(true);
    setLoading(!loading);
  }
  const [showIM, setImLoading] = React.useState(true);
  const [showBike, setBikeLoading] = React.useState(true);
  const [caseNumber,setCaseNumber] = React.useState("")
  React.useEffect(() => {
    for (let i = 0; i < Configuration.Company.length; i++) {
      console.log("444", Configuration.Company[i].logo);
      if (Configuration.Company[i].Cname === localStorage.getItem("company")) {
        console.log("444", Configuration.Company[i].immigo_case_number_display);
        setImLoading(Configuration.Company[i].immigo_case_number_display);
        setBikeLoading(Configuration.Company[i].is_bike_enable);
        setCaseNumber(Configuration.Company[i].immigo_case_number_display_name);
      }
    }
  }, []);
  const priceChange = (e) => {
    console.log(e.target.value);
    setPrice(e.target.value);
  };
  function goback() {
    navigate("/services");
  }
  const [selectedDate, handleDateChange] = React.useState(new Date());

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  const setTimeDesc = (date) => {
    let fixDate = new Date().setHours(17, 0, 0); // for 3:00:00 pm
    let currDate = date;

    if (fixDate < currDate) {
      setOpenError(true);
    }
    setPickup(date);
    let temp = moment(date).format("hh:mm");
    //alert("dfd")
    console.log(temp);
    if (
      temp === "08:00" ||
      temp === "08:30" ||
      temp === "09:30" ||
      temp === "09:00" ||
      temp === "10:00" ||
      temp === "10:30" ||
      temp === "11:00" ||
      temp === "11:30"
    ) {
      setAlignmentPickup("AM");
    } else {
      setAlignmentPickup("PM");
    }
  };

  const PickupTimeInput = forwardRef(({ value, onClick }, ref) => (
    <FormControl
      fullWidth
      className={clsx(classes.margin, classes.textField)}
      variant="outlined"
    >
      <OutlinedInput
        id="outlined-adornment-weight"
        name="pktime"
        onClick={onClick}
        ref={ref}
        value={value}
        placeholder="Pick Up Time if any"
        startAdornment={
          <InputAdornment position="start">
            {" "}
            <img src="./Images/clock-two.svg"></img>
          </InputAdornment>
        }
        aria-describedby="outlined-weight-helper-text"
        inputProps={{
          "aria-label": "weight",
        }}
        labelWidth={0}
        className={clsx(classes.searchInput, classes.timeSelector)}
        endAdornment={
          <ToggleButtonGroup
            fullWidth
            color="info"
            id="pickupAA"
            value={alignmentPickup}
            exclusive
            onChange={(e, value) => setAlignmentPickup(value)}
            className={classes.timeGroup}
            onClick={(e) => e.stopPropagation()}
          >
            <ToggleButton
              className={clsx("toggledts", "toggle-button-left")}
              value="AM"
            >
              AM
            </ToggleButton>
            <ToggleButton
              className={clsx("toggledts", "toggle-button-right")}
              value="PM"
            >
              PM
            </ToggleButton>
          </ToggleButtonGroup>
        }
      />
    </FormControl>
  ));

  const [personName, setPersonName] = React.useState("");

  const handleChange = (event) => {
    console.log("fffff", event.target.value.value);
    setPersonName(event.target.value.value);
    let params = {
      user_id: localStorage.getItem("userId"),
      location: address,
      type_photo: event.target.value.value,
      photo_lat: String(coordinate.lat),
      photo_lng: String(coordinate.lng)
    };
    axios.post(priceUrl, params).then((res) => {
      console.log("PRICEEEEEEE", res.data);
      setPrice(res.data.estimatedPrice);
      setPriceBack(res.data.estimatedPrice);

      try {
      } catch (error) {
        console.error();
      }
    });
  };

  return (
    <>
      <Allservices></Allservices>
      <Grid container className={classes.section_start}>
        <Grid container className={classes.newbg}>
          <Grid container className={classes.secn}>
            <Grid container className={classes.ht}>
              <Grid container className={classes.send_bg}>
                <Grid item xs={8} md={6} lg={6}>
                  <div className={classes.heading}>
                    <img
                      className={classes.send_img}
                      src="./Images/Io.svg"
                      onClick={() => goback()}
                    ></img>
                    &nbsp;&nbsp;
                    <div className={classes.send_heading}> Digital Photo Service</div>
                  </div>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                  <div className={classes.send_header}>
                    <ColoredLine color="#131C4C" />
                  </div>
                </Grid>
                <Grid item xs={12} md={12} lg={12} className={classes.vat}>
                  {/* Send packages to your clients/companies in a secure manner
                  with double authentication features within the same day. */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <TabsUnstyled defaultValue={0} className={classes.ht}>
            <TabsList className={classes.tabList}>
              <Tab className={classes.tabItem} onClick={() => setActiveTab(1)}>
                <Box className={classes.tabContent}>
                  <img
                    className={classes.icon}
                    src={
                      activeTab != 1
                        ? "./Images/clock_dark.png"
                        : "./Images/clock_lite.png"
                    }
                    width={49}
                    height={49}
                  ></img>
                  {/*<AccessTimeIcon className={classes.icon}></AccessTimeIcon>*/}
                  <div className={classes.tab2}>
                    <span className={classes.mainTab}>Deliver Now</span>
                    <span
                      className={clsx(
                        classes.mainTab2,
                        activeTab != 1 && classes.mainInactive
                      )}
                    >
                      Within 2 Hours &nbsp;<b></b>&nbsp;
                    </span>
                  </div>
                </Box>
              </Tab>
              <Tab className={classes.tabItem} onClick={() => setActiveTab(2)}>
                <Box className={classes.tabContent}>
                  <img
                    className={classes.icon}
                    src={
                      activeTab != 2
                        ? "./Images/date_dark.png"
                        : "./Images/date_lite.png"
                    }
                    width={46}
                    height={51}
                  ></img>
                  {/*<CalendarTodayIcon className={classes.icon}></CalendarTodayIcon>*/}
                  <div className={classes.tab2}>
                    <span className={classes.mainTab}>Schedule for Later</span>
                    <span
                      className={clsx(
                        classes.mainTab2,
                        activeTab != 2 && classes.mainInactive
                      )}
                    >
                      Next Day Delivery &nbsp;<b></b>&nbsp;
                    </span>
                  </div>
                </Box>
              </Tab>
            </TabsList>
            <TabPanel value={0}>
              <div></div>
              <div className={classes.will}>
                We will assign the nearest delivery agent to pick up and deliver
                as soon as possible
              </div>

              <div className={classes.req}>
                <p className={classes.revert}>
                  <b className={classes.reqi}>
                    Select based on your requirement :
                  </b>
                  <p
                    className={
                      alignmentTrans === "bike"
                        ? classes.two_wheel
                        : classes.two_wheel_inactive
                    }
                  >
                    <b>2 Wheeler</b>
                  </p>
                  <div className={classes.del_icon2}>
                    {showBike ? (
                      <ToggleButtonGroup
                        fullWidth
                        color="info"
                        id="pickupAA"
                        value={alignmentTrans}
                        // value={"car"}
                        exclusive
                        onChange={(e, value) => {
                          setAlignmentTransport(value);
                          callPriceParamsPhotoService(value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ToggleButton
                          className={clsx("toggledtsCar", "toggle-button-left")}
                          value="bike"
                        >
                          {alignmentTrans === "bike" ? (
                            <img src="./Images/wbike.svg"></img>
                          ) : (
                            <img src="./Images/gbike.svg"></img>
                          )}
                        </ToggleButton>
                        <ToggleButton
                          className={clsx(
                            "toggledtsCar",
                            "toggle-button-right"
                          )}
                          value="car"
                        >
                          {alignmentTrans === "bike" ? (
                            <img src="./Images/gcar.svg"></img>
                          ) : (
                            <img src="./Images/wcar.svg"></img>
                          )}
                        </ToggleButton>
                      </ToggleButtonGroup>
                    ) : (
                      <ToggleButtonGroup
                        fullWidth
                        color="info"
                        id="pickupAA"
                        value={"car"}
                        // value={"car"}
                        exclusive
                        //onChange={(e, value) => setAlignmentTransport(value)}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ToggleButton
                          className={clsx("toggledtsCar", "toggle-button-left")}
                          value="bike"
                        >
                          {alignmentTrans === "bike" ? (
                            <img src="./Images/wbike.svg"></img>
                          ) : (
                            <img src="./Images/gbike.svg"></img>
                          )}
                        </ToggleButton>
                        <ToggleButton
                          className={clsx(
                            "toggledtsCar",
                            "toggle-button-right"
                          )}
                          value="car"
                        >
                          {alignmentTrans === "bike" ? (
                            <img src="./Images/gcar.svg"></img>
                          ) : (
                            <img src="./Images/wcar.svg"></img>
                          )}
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  </div>
                  <p
                    className={
                      alignmentTrans === "bike"
                        ? classes.four_wheel
                        : classes.four_wheel_active
                    }
                  >
                    4 Wheeler
                  </p>
                </p>{" "}
                &nbsp;
                {/*<p className={mode === 'bike' ? classes.two_wheel : classes.two_wheel_inactive}><b>2 Wheeler</b></p>
                <div className={classes.del_icon}>
          
                  <img src='./Images/biked.svg' className={mode === 'bike' ? classes.biked : classes.biked_inactive} width={41} height={31}></img>&nbsp;
                </div>
                <SwitchUnstyled component={Root} onChange={(e, value) => setMode(e.target.checked ? 'bike' : 'car')} />
                <img src='./Images/sedan.png' height={60} className={mode === 'bike' && classes.sedan}></img>&nbsp;
                <p className={mode === 'bike' ? classes.four_wheel : classes.four_wheel_active}>4 Wheeler</p>
             */}{" "}
              </div>
              {/*Weights not in cooperate login */}
              {/*<div className={classes.content}>
                <div>Weights</div>
                <div className={classes.content}>
                <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  className={classes.weightGroup}
                  fullWidth
                >
                  <ToggleButton className={classes.weightButton} value="web">Upto 1kg</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="android">Upto 5kg</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios1">Upto 10kg</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios2">Upto 15kg</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios23">Upto 20kg</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios4">20+</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios5">Unsure</ToggleButton>

                </ToggleButtonGroup>
                </div>

  </div>*/}

              <form onSubmit={handleSubmitPhoto}>
                <div className={classes.content1}>
                  {showIM ? (<>
                  <div className={classes.send_label}>{caseNumber}</div>
                  <Grid container spacing={2}>
                  <Grid item xs={12} md={4} lg={4}>
                    <FormControl
                      fullWidth
                      className={clsx(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <OutlinedInput
                        id="outlined-adornment-weight"
                        name="immigo"
                        type="text"
                        onChange={(event) => ImgNumber(event)}
                        placeholder={"Enter " + caseNumber}
                        startAdornment={
                          <InputAdornment position="start">
                            {" "}
                            <img src="./Images/imigo.svg"></img>
                          </InputAdornment>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          maxLength:8,
                          "aria-label": "weight"
                        
                        }}
                        labelWidth={0}
                        className={classes.searchInput}
                      />
                    </FormControl>
                    {errorImg ? (
                      <>
                        <div className={classes.errors}>
                          Enter{caseNumber}
                        </div>
                      </>
                    ) : null}
                  </Grid>
                  </Grid>
                  <br />
                  <br />
                  </>):
                  (<></>)} 

                  <div className={classes.send_label}>Client Fulfilment Address</div>
                  <div className={classes.content}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                          {/*} <OutlinedInput
                  id="outlined-adornment-weight"
                  placeholder='Address'
                  name="address"
                  startAdornment={<InputAdornment position="start"> <img src='./Images/loc1.svg'></img></InputAdornment>}
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                  labelWidth={0}
                />*/}
                          <PlacesAutocomplete
                            value={address}
                            onChange={setAddress}
                            onSelect={handleSelect}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <OutlinedInput
                                  id="outlined-adornment-weight"
                                  placeholder="Address"
                                  fullWidth
                                  name="address"
                                  startAdornment={
                                    <InputAdornment position="start">
                                      {" "}
                                      <img src="./Images/loc1.svg"></img>
                                    </InputAdornment>
                                  }
                                  aria-describedby="outlined-weight-helper-text"
                                  {...getInputProps({
                                    placeholder: "Search Places ...",
                                    className: "location-search-input",
                                  })}
                                  labelWidth={0}
                                  className={classes.searchInput}
                                />

                                <div className={classes.locationdropdown}>
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          padding: "10px",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          padding: "10px",
                                        };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </FormControl>
                        {error1 ? (
                          <>
                            <div className={classes.errors}>
                              Select pickup location
                            </div>
                          </>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={1.2} lg={1.2}>
                      <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                       <PhoneInput
                          country={"ae"}
                          onlyCountries={["ae"]}
                          inputClass="phone-input-field"
                          buttonClass="phone-input-button"
                        />
                        </FormControl>
                        </Grid>
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            name="mobileNo"
                            onChange={(event) => pickupPhone(event)}
                            placeholder="Phone Number"
                            startAdornment={
                              <InputAdornment position="start">
                                <img src="./Images/mobile.svg"></img>
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              "aria-label": "weight",
                            }}
                            labelWidth={0}
                            className={classes.searchInput}
                          />
                        </FormControl>
                        {error2 ? (
                          <>
                            <div className={classes.errors}>
                              Enter mobile number
                            </div>
                          </>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            name="email"
                            onChange={(event) => pickupEmail(event)}
                            placeholder="User Email Address"
                            startAdornment={
                              <InputAdornment position="start">
                                {" "}
                                <img src="./Images/email-send.svg"></img>
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              "aria-label": "weight",
                            }}
                            labelWidth={0}
                            className={classes.searchInput}
                          />
                        </FormControl>
                        {error3 ? (
                          <>
                            <div className={classes.errors}>Enter E-mail</div>
                          </>
                        ) : null}
                      </Grid>
                      <Grid xs={12} item md={4} lg={4}>
                        <DatePicker
                          selected={pickup}
                          onChange={(date) => setTimeDesc(date)}
                          customInput={<PickupTimeInput />}
                          showTimeSelect
                          showTimeSelectOnly
                          filterTime={filterPassedTime}
                          excludeTimes={[
                            setHours(setMinutes(new Date(), 0), 0),
                            setHours(setMinutes(new Date(), 30), 0),
                            setHours(setMinutes(new Date(), 0), 1),
                            setHours(setMinutes(new Date(), 30), 1),
                            setHours(setMinutes(new Date(), 0), 2),
                            setHours(setMinutes(new Date(), 30), 2),
                            setHours(setMinutes(new Date(), 0), 3),
                            setHours(setMinutes(new Date(), 30), 3),
                            setHours(setMinutes(new Date(), 0), 4),
                            setHours(setMinutes(new Date(), 30), 4),
                            setHours(setMinutes(new Date(), 0), 5),
                            setHours(setMinutes(new Date(), 30), 5),
                            setHours(setMinutes(new Date(), 0), 6),
                            setHours(setMinutes(new Date(), 30), 6),
                            setHours(setMinutes(new Date(), 0), 7),
                            setHours(setMinutes(new Date(), 30), 7),

                            setHours(setMinutes(new Date(), 0), 23),
                            setHours(setMinutes(new Date(), 30), 23),
                            setHours(setMinutes(new Date(), 0), 22),
                            setHours(setMinutes(new Date(), 30), 22),
                            setHours(setMinutes(new Date(), 0), 21),
                            setHours(setMinutes(new Date(), 30), 21),
                            setHours(setMinutes(new Date(), 0), 20),
                            setHours(setMinutes(new Date(), 30), 20),
                            setHours(setMinutes(new Date(), 0), 19),
                            setHours(setMinutes(new Date(), 30), 19),
                            setHours(setMinutes(new Date(), 30), 18),
                            setHours(setMinutes(new Date(), 0), 18),
                            setHours(setMinutes(new Date(), 30), 17),
                          ]}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                        />

                        {/*} <MuiPickersUtilsProvider utils={DateFnsUtils}>

                                  <TimePicker value={selectedDate} onChange={handleDateChange} />

                                </MuiPickersUtilsProvider>*/}
                        {error4 ? (
                          <>
                            <div className={classes.errors}>Select time</div>
                          </>
                        ) : null}
                      </Grid>

                      
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                        >
                          <Select
                            displayEmpty
                            className={classes.searchInput}
                            name="personName"
                            id="outlined-adornment-weight"
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <span className={classes.photoQty}>
                                    Photo Specification
                                  </span>
                                );
                              }
                              return personName;
                            }}
                            value={personName}
                            onChange={handleChange}
                          >
                            <MenuItem disabled value="">
                              Photo Specification
                            </MenuItem>
                            {names.map((name) => (
                              <MenuItem key={name} value={name}>
                                <div>
                                  <span>{name.value}</span>&nbsp;&nbsp;
                                  <span>({name.size})</span>
                                </div>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {error6 ? (
                          <>
                            <div className={classes.errors}>Enter  Photo Specification</div>
                          </>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={8} lg={8}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            placeholder="Instruction"
                            name="pkinstruction"
                            startAdornment={
                              <InputAdornment position="start">
                                <img src="./Images/direction.svg"></img>
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              "aria-label": "weight",
                            }}
                            labelWidth={0}
                            onChange={(event) => pickupDesc(event)}
                            className={classes.searchInput}
                          />
                        </FormControl>
                        {error7 ? (
                          <>
                            <div className={classes.errors}>
                              Enter pickup description
                            </div>
                          </>
                        ) : null}
                      </Grid>
                      <div style={{paddingLeft:'13px',marginTop:'20px'}} className={classes.send_label}>Number of photos to capture</div>
                     
                      <Grid item xs={12} md={12} lg={12}>
                      <span style={{ display: "flex" }}>
                          <span style={{ marginTop: "10px",fontSize:'12px' }} className={classes.send_label}>
                            Quantity &nbsp;
                          </span>{" "}
                      <div className="passd">
                            <IconButton
                               onClick={() => removePhotoQuan()}
                              className="valDocLeft"
                            >
                              <RemoveIcon></RemoveIcon>
                            </IconButton>
                            <Button className="newed">{photoQuan}</Button>
                            <IconButton
                               onClick={() => addPhotoQuan()}
                              className="valDoc"
                            >
                              <AddIcon></AddIcon>
                            </IconButton>
                          </div>
                          </span>
                      </Grid>
                      {photoName.map((inputs, index) => (
                      <Grid item xs={12} md={4} lg={4} key={index}>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            name="name"
                            defaultValue={inputs.name}
                            onChange={(event) => pickupNameSet(event,index)}
                            placeholder="Name"
                            startAdornment={
                              <InputAdornment position="start">
                                {" "}
                                <img
                                  className="nameus"
                                  src="./Images/name.svg"
                                ></img>
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              "aria-label": "weight",
                            }}
                            labelWidth={0}
                            className={classes.searchInput}
                          />
                        </FormControl>
                        {error5 ? (
                          <>
                            <div className={classes.errors}>Enter Name</div>
                          </>
                        ) : null}
                      </Grid>))}
                    </Grid>
                  </div>
                </div>
                {/*ADD STOP*/}

                {/*END STOP*/}

                {/*<div className={classes.content}>
                  <Grid container spacing={3}>
                    <Grid item md={4} lg={4} >
                      <div className={classes.send_label}>
                        Approx Parcel Value
                      </div>
                      <FormControl fullWidth className={clsx(classes.margin, classes.textField)} variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          placeholder='Enter parcel value'
                          onChange={(e) => priceChange(e)}

                          endAdornment={<InputAdornment position="end"> <p><b>AED</b></p></InputAdornment>}
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            'aria-label': 'weight',
                          }}
                          labelWidth={0}
                          className={classes.searchInput}
                        />
                      </FormControl>
                    </Grid>
                    <Grid container item md={8} lg={8} display="block">
                      <div className={classes.send_label}>
                        Secure Your Parcel
                      </div>
                      <Grid xs={6}>
                        <FormControl fullWidth className={clsx(classes.margin, classes.textField)} variant="outlined">
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            placeholder='Parcel value'
                            onChange={(e) => priceChange(e)}

                            endAdornment={<InputAdornment position="end"> <p><b>AED</b></p></InputAdornment>}
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              'aria-label': 'weight',
                            }}
                            labelWidth={0}
                            className={classes.searchInput}
                          />
                        </FormControl>
                      </Grid>
                      <p className={classes.secureParcelInfo}>0 AED : Additional charges for securing parcel</p>
                      <p className={classes.secureParcelWarning}>Secure your important packages to retrieve the value in case of loss or damage done during delivery. Valid upto AED 5000.</p>
                    </Grid>
                  </Grid>
                </div>*/}

                {/*<div className={classes.content1}>
                  <div className={classes.send_label}>
                    Payment Type
                  </div>
                  <div className={classes.content}>
                    <Grid container spacing={2}>
                      <Grid xs={2} item>
                        <Button className={classes.weightSelectorButton}>
                          Cash
                        </Button>
                      </Grid>
                      <Grid xs={3} item>
                        <Button className={classes.weightSelectorButton}>
                          Credit / Debit Card
                        </Button>
                      </Grid>
                      <Grid xs={2.5} item>
                        <Button className={classes.weightSelectorButton}>
                          e-Dirham Card
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                          </div>*/}

                {/*Payment not in cooperate login */}
                {/*} <div className={classes.content}>
            <Grid container spacing={3}>
             <Grid item md={12} lg={12} >
               <div>
                 Payment Type
               </div>
               <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  className={classes.weightGroup}
                  fullWidth
                >
                  <ToggleButton className={classes.weightButton} value="web">Cash</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="android">Credit/Debit Card</ToggleButton>
                  <ToggleButton className={classes.weightButton} value="ios1">e-Dirham Card<br/>(0 Balance)Top up Now</ToggleButton>
                  


                </ToggleButtonGroup>

               </Grid>
               </Grid>
                </div>*/}

                {/*} <div className={classes.content1}>
                  <div className={classes.send_label}>
                    Other
                  </div>
                  <Grid container spacing={3}>
                  
                     <Grid item md={4} lg={4} >

                        <ToggleButton

                          value="check"
                          selected={selected}
                          onChange={() => {
                            setSelected(!selected);
                          }}
                        >
                          <CheckIcon />
                        </ToggleButton>&nbsp;&nbsp;Notify recipient by Whatsapp Messages
                      </Grid>
                    <Grid item md={4} lg={4} >
                      <ToggleButton
                        value="check"
                        selected={selected4}
                        onChange={() => {
                          setSelected4(!selected4);
                        }}
                      >
                        <CheckIcon />
                      </ToggleButton> &nbsp;&nbsp;Notify recipient by SMS
                    </Grid>
                  </Grid>
                </div>*/}

                <div className={classes.content}>
                  <Grid container spacing={3}>
                    <Grid item md={3} lg={3}></Grid>
                    {price !== "" ? (
                      <Grid item md={6} lg={6}>
                        <div className={classes.total}>
                          <b className={classes.price_cont}>
                            Total Estimated Price
                          </b>
                          &nbsp;&nbsp;
                          <img
                            className={classes.price_img}
                            src="./Images/info.svg"
                          ></img>
                          <b className={classes.price_tag}>
                            &nbsp;&nbsp;{price}
                          </b>
                          &nbsp;AED
                        </div>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    <Grid item md={3} lg={3}></Grid>
                  </Grid>
                </div>
                <div className={classes.divider}></div>
                {/*} <div className={classes.estimationContainer}>
                  <p className={classes.totalPrice}>Total Estimated Price : <span className={classes.totalPriceCount}>65.00</span> <span className={classes.totalPriceUnit}>AED</span></p>
                </div>*/}

                <div className={classes.content}>
                  <Grid container spacing={3}>
                    <Grid item md={4} lg={4}></Grid>
                    <Grid item xs={10} md={4} lg={4}>
                      <button className={classes.service_btn} type="submit">
                        {loaded}
                      </button>
                    </Grid>
                    <Grid item md={4} lg={4}></Grid>
                  </Grid>
                </div>
              </form>
              <div className={classes.content5}>
                <Grid container spacing={3} className={classes.contnew}>
                  <span>
                    By Clicking ‘Submit order’ you are forwarding your request
                    to couriers and agree to Our Terms and Conditions along with
                    the{" "}
                    <u>
                      <b style={{ cursor: "pointer" }} onClick={clause}>
                        clauses of the agreements
                      </b>
                    </u>
                  </span>
                </Grid>
              </div>
            </TabPanel>
            <TabPanel value={1}>
              {/* <ScheduleLater></ScheduleLater> */}
              <PhotoScheduleLater></PhotoScheduleLater>
            </TabPanel>

            {/*schedule later part begins */}
          </TabsUnstyled>
          <Grid item md={12} lg={12}>
            <div className="footed">
              <Footer></Footer>
            </div>
          </Grid>
        </Grid>
      </Grid>

      {/*error popup */}
      <Dialog
        open={openErrorQuan}
        onClose={() => handleCloseErrorQuan()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Maximum quantity limit is 3. Please place a separate order for additional photos.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseErrorQuan()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openError}
        onClose={() => handleCloseError()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sorry, pickup time chosen is not within agreed SLA, please choose a
            pick up time 2 hours prior to working hours (8:00 AM to 7:00 PM -
            pick up time cannot be post 5:00 PM
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseError()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDocError}
        onClose={() => handleCloseErrorDoc()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select documents to be sent
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseErrorDoc()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLoc}
        onClose={() => handleCloseLoc()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select location from dropdown
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseLoc()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
      open={openOrderPlaced}
      onClose={() => {}} // Removed the close handler
      disableEscapeKeyDown // Prevents closing with Escape key
      disableBackdropClick // Deprecated but kept for reference
      hideBackdrop={false} // Shows the backdrop but prevents clicks
      aria-labelledby="order-dialog-title"
      aria-describedby="order-dialog-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px",
            padding: "24px",
            borderRadius: "12px",
            textAlign: "center",
          },
        },
        // Prevent closing on backdrop click
        "& .MuiBackdrop-root": {
          pointerEvents: "none"
        }
      }}
    >
      <DialogTitle 
        id="order-dialog-title" 
        sx={{ 
          fontSize: "1.5rem", 
          fontWeight: "600",
          fontFamily: "'Poppins', sans-serif" // Optional: for consistent font
        }}
      >
        Order Placed!
      </DialogTitle>
      <DialogContent>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 32 32" 
          width="256px" 
          height="180px"
          style={{ margin: '20px auto' }} // Added margin for better spacing
        >
          <polyline 
            fill="none" 
            stroke="#131C4C" 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            points="28,8 16,20 11,15"
          />
          <path 
            stroke="#131C4C" 
            fill="#131C4C" 
            d="M26.7,13.5c0.2,0.8,0.3,1.6,0.3,2.5c0,6.1-4.9,11-11,11S5,22.1,5,16S9.9,5,16,5c3,0,5.7,1.2,7.6,3.1l1.4-1.4C22.7,4.4,19.5,3,16,3C8.8,3,3,8.8,3,16s5.8,13,13,13s13-5.8,13-13c0-1.4-0.2-2.8-0.7-4.1L26.7,13.5z"
          />
        </svg>
        <DialogContentText
          id="order-dialog-description"
          sx={{ 
            fontSize: "1rem", 
            color: "#555", 
            margin: "16px 0",
            fontFamily: "'Poppins', sans-serif" // Optional: for consistent font
          }}
        >
          Your order has been successfully placed.Click the button below to view your order details.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: "12px", padding: "16px 0" }}>
        <Button
          onClick={() => navigateToOrders()}
          sx={{
            backgroundColor: "#131C4C",
            color: "#fff",
            borderRadius: "8px",
            padding: "10px 24px", // Slightly larger padding
            fontWeight: "500",
            textTransform: "none", // Prevents all-caps
            "&:hover": {
              backgroundColor: "#388e3c",
            },
            "&:focus": {
              backgroundColor: "#388e3c", // Consistent hover/focus state
            },
            // Mobile responsiveness
            "@media (max-width: 600px)": {
              width: "80%",
              padding: "12px 16px",
            }
          }}
        >
          View Orders
        </Button>
      </DialogActions>
    </Dialog>
      <Dialog
        open={prefer}
        onClose={() => handleClosePrefer()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Grid xs={12} md={12} lg={12} className="jk">
            <ToggleButtonGroup
              fullWidth
              color="info"
              id="pickupAA"
              value={preferIcon}
              exclusive
              onChange={(e, value) => setPreferIcon(value)}
              className={classes.timeGroup1}
              // onClick={(e) => e.stopPropagation()}
            >
              <ToggleButton
                className={clsx("toggledtsPrefer", "toggle-button-left")}
                value="black"
              >
                Black
              </ToggleButton>
              <ToggleButton
                className={clsx("toggledtsPrefer", "toggle-button-right")}
                value="white"
              >
                White
              </ToggleButton>
            </ToggleButtonGroup>
            <span className="prefered" onClick={() => handleClosePrefer()}>
              <img src="./Images/crosss.svg"></img>
            </span>
          </Grid>
          <Grid xs={2} md={2} lg={2}></Grid>

          {preferIcon === "black" ? (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.preferGroup}
            >
              <div>
                <span className="tamper">
                  Tamper proof black bag dimension{" "}
                </span>
                <span className="dark">(2 AED)</span>
              </div>
              <br />
              <Box sx={{ marginLeft: "40px" }}>
                <img src="./Images/black_bag.png"></img>)
              </Box>
            </DialogContentText>
          ) : (
            <>
              <DialogContentText
                id="alert-dialog-description"
                className={classes.preferGroup}
              >
                <div>
                  <span className="tamper">
                    Tamper proof white bag dimension{" "}
                  </span>
                  <span className="dark">(3 AED)</span>
                </div>
                <br />
                <Box sx={{ marginLeft: "40px" }}>
                  <img src="./Images/white_bag.png"></img>
                </Box>
              </DialogContentText>
            </>
          )}
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        open={friday}
        onClose={() => handleFriday()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {frMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleFriday()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openBag}
        onClose={() => handleBag()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select Bag
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleBag()} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openA3}
        onClose={() => handleClosePrefer()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Grid xs={12} md={12} lg={12} className="jk">
            <ToggleButtonGroup
              fullWidth
              color="info"
              id="pickupAA"
              exclusive
              className={classes.timeGroup1}
              // onClick={(e) => e.stopPropagation()}
            >
              <ToggleButton
                className={clsx("toggledtsPrefer", "toggle-button-right")}
                value="white"
                selected
              >
                Black
              </ToggleButton>
            </ToggleButtonGroup>
            <span className="prefered" onClick={() => handleCloseA3()}>
              <img src="./Images/crosss.svg"></img>
            </span>
          </Grid>
          <Grid xs={2} md={2} lg={2}></Grid>

          <DialogContentText
            id="alert-dialog-description"
            className={classes.preferGroup}
          >
            <div>
              <span className="tamper">Tamper proof black bag dimension</span>
              <span className="dark">(5 AED)</span>
            </div>
            <br />
            <Box sx={{ marginLeft: "5px" }}>
              <img height={"500px"} width={"350px"} src="./Images/a3.png"></img>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openClause}
        onClose={handleCloseClause}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        className="wdialog"
      >
        <Fade in={openClause}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              component="h2"
              className="closed"
            >
              <b>Terms and Conditions</b>
              <div id="mdiv" onClick={handleCloseClause}>
                <div class="mdiv">
                  <div class="md"></div>
                </div>
              </div>
            </Typography>

            <Typography id="transition-modal-title" variant="h5" component="h2">
              <b>User Terms</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  These terms of use (“Terms of Use”) mandate the terms on which
                  users (“You” or “Your” or “Yourself” or “Users”) interested in
                  browsing or availing Jiffy Services (defined below), and
                  accessing the platform www.Jiffy.ae and the mobile application
                  owned and operated by Jiffy Delivery Services (Jiffy), a Sole
                  Establishment incorporated under the law of Dubai, having its
                  registered office at Office suite # 207, Misa Business Centre, Blue Wave Tower, Wadi Al Safa 5, 
                  Dubai - UAE,
                  collectively referred to as the “Platform” connects with the
                  delivery partners registered on the Platform (“Delivery
                  Partners”) to avail the Jiffy Services.
                </li>
                <li className="listed">
                  Please read the Terms of Use carefully before using the
                  Platform or registering on the Platform or accessing any
                  material or information through the Platform. By clicking on
                  the “I Accept” button, You accept this Terms of Use and agree
                  to be legally bound by the same.
                </li>
                <li className="listed">
                  Use of and access to the Platform is offered to You upon the
                  condition of acceptance of all the terms, conditions and
                  notices contained in this Terms of Use and Privacy Policy,
                  along with any amendments made by Jiffy at its sole discretion
                  and posted on the Platform from time to time.
                </li>
                <li className="listed">
                  For the purposes of these Terms of Use, the term ‘Jiffy’ or
                  ‘Us’ or ‘We’ refers to Jiffy. The term ‘You’ refers to the
                  user or visitor of the Website and/or App. When You use our
                  services, You will be subject to the terms, guidelines and
                  policies applicable to such service and as set forth in these
                  Terms of Use. As long as you comply with these Terms of Use,
                  We grant You a personal, non-exclusive, non-transferable,
                  limited privilege to enter and use our Platforms and services.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>PART A – GENERAL TERMS RELATING TO JIFFY SERVICES</b>
            </Typography>
            <Typography id="transition-modal-title" variant="h5" component="h2">
              <b>1. Registration:</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  a. You shall be permitted to access the Platform, avail the
                  Jiffy Services and connect with Delivery Partners on the
                  Platform only upon creating an Account (as defined below) and
                  obtaining a registration on the Platform. Your ability to
                  continue using the Platform, Jiffy Services is subject to Your
                  continued registration on the Platform. You will be required
                  to enter Your personal information including your name,
                  contact details, valid phone number while registering on the
                  Platform.
                </li>
                <li className="listed">
                  b. As a part of the registration, You may be required to
                  undertake a verification process to verify Your personal
                  information and setting up the Account. Jiffy shall have the
                  right to display the information, feedback, ratings, reviews
                  etc. provided by You on the Platform. You agree and accept
                  that as on the date of Your registration on the Platform, the
                  information provided by You is complete, accurate and
                  up-to-date. In the event of any change to such information,
                  You shall be required to promptly inform Jiffy of the same, in
                  writing, at least 1 (one) week prior to the date on which such
                  change shall take effect. You acknowledge and accept that
                  Jiffy has not independently verified the information provided
                  by You. Jiffy shall in no way be responsible or liable for the
                  accuracy or completeness of any information provided by You.
                  If You provide any information that is untrue, inaccurate, not
                  current or incomplete, or Jiffy has reasonable grounds to
                  suspect that such information is untrue, inaccurate, not
                  current or incomplete, Jiffy reserves the right to suspend or
                  terminate Your Account (defined below) and refuse any and all
                  current or future use of the Platform (or any portion thereof)
                  at any time.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>2. Jiffy Services:</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  a. The Platform provides You with the following services
                  (“Jiffy Services”):
                </li>

                <li className="listed">
                  We identify and use your IP address to help diagnose problems
                  with our server and to administer our Website. Your IP address
                  is also used to help identify you and to gather broad
                  demographic information.
                </li>
                <li className="listed">
                  ii. It allows you to pick up- and drop off packages from one
                  location to the other through the Delivery Partner (“Pick Up
                  and Drop Off Services”);
                </li>
                <li className="listed">
                  iii. It allows You to give ratings, write comments and reviews
                  about Delivery Partners;
                </li>
                <li className="listed">
                  iv. It facilitates improvement in the quality of the services
                  provided by Jiffy on the Platform based on User ratings,
                  reviews and feedback provided on the Platform.
                </li>
                <li className="listed">
                  b. Once the Delivery Services/Pick-Up and Drop Off Services
                  have been completed or delivered, as the case may be, You
                  shall promptly notify the same on the Platform.
                </li>
                <li className="listed">
                  c. Jiffy may, at its absolute sole discretion, add, modify,
                  upgrade, extend, withdraw or alienate any of the Jiffy
                  Services listed above from time to time. Jiffy does not
                  provide any guarantee to You that the Jiffy Services will be
                  made available to You at all times.
                </li>
                <li className="listed">
                  d. You hereby agree and acknowledge that Jiffy is only a
                  facilitator between You and Delivery Partners and Jiffy only
                  provides You with access to the Platform to connect with
                  Delivery Partners for You to initiate transactions on the
                  Platform. You hereby agree and acknowledge that Jiffy will not
                  be a party to any of the transactions that are initiated by
                  You through the Platform and Jiffy shall not be liable in any
                  manner or incur any liability with respect to the services
                  performed by the Delivery Partners. Further, You hereby agree
                  and acknowledge that Jiffy shall not be liable for the
                  conduct, acts and omissions of the Delivery Partners in the
                  course of providing their services to You, or for any loss or
                  damage to the Item or otherwise caused to You as a consequence
                  of or in relation to the services being provided to You by the
                  Delivery Partner, as the case may be.
                </li>
                <li className="listed">
                  e. You shall be eligible to avail the Jiffy Services as per
                  applicable laws.
                </li>
                <li className="listed">
                  f. You shall not initiate any transaction for any Item on the
                  Platform which is illegal, immoral, unethical, unlawful,
                  unsafe, contains any harmful substance and/ or is in violation
                  of this Terms of Use and applicable laws. You specifically
                  agree that You shall not initiate any transaction on the
                  Platform for the delivery of any alcoholic beverages, narcotic
                  drug or psychotropic substance, etc. Further, You hereby
                  acknowledge and agree that Jiffy shall not be liable for any
                  indirect, direct damage or loss, cost, expense incurred by You
                  in relation to the transactions initiated by You on the
                  Platform.
                </li>
                <li className="listed">
                  g. Jiffy does not check or verify the packages that are being
                  picked up and dropped off on behalf of You or the Items that
                  are being delivered to You by the Delivery Partner, and
                  therefore Jiffy shall have no liability with respect to the
                  same. However, if it comes to the knowledge of Jiffy that You
                  have packaged any illegal or dangerous substance or availed
                  the Pick- up and Drop Off Services using the Platform to
                  deliver any illegal or dangerous substance, Jiffy shall have
                  the right to report You to the government authorities and take
                  other appropriate legal actions against You.
                </li>
                <li className="listed">
                  h. You hereby acknowledge that Jiffy shall not be liable for
                  any damages of any kind arising from Your use of the Jiffy
                  Services, including, but not limited to direct, indirect,
                  incidental, punitive, and consequential damages.
                </li>
                <li className="listed">
                  i. Jiffy shall be entitled at any time, without giving any
                  reason, to terminate Your request for any Jiffy Service.
                </li>
                <li className="listed">
                  j. You hereby agree that Jiffy shall not be liable for any
                  conduct or misbehaviour or actions of Delivery Partner with
                  respect to any transactions initiated on the Platform.
                  Further, You agree that Jiffy has no control over the Items
                  dispatched/ received by You by the Delivery Partners and
                  therefore, Jiffy shall not incur any liability with respect to
                  such Items. However, keeping in mind the interests of the
                  Users, We have informed our Delivery Partners to ensure that
                  Items are handled properly and with due care to avoid any form
                  of damage to the Item.
                </li>
                <li className="listed">
                  k. You hereby agree that scheduling and rescheduling a
                  transaction on the Platform depends upon the availability of
                  Delivery Partners around Your area at the time of such
                  scheduling and re-scheduling a transaction. Should You choose
                  to reschedule a transaction on the Platform at a later point
                  of time, You shall cancel the current transaction on the
                  Platform (if initiated) and initiate a new transaction on the
                  Platform, as per Your convenient time.
                </li>
                <li className="listed">
                  l. If a transaction initiated by You on the Platform cannot be
                  completed, Jiffy shall notify You on the Platform.
                </li>
                <li className="listed">
                  m. You agree to provide as much information as possible on the
                  Platform with respect to the Items/services You wish to avail,
                  using the Platform.
                </li>
                <li className="listed">
                  n. Jiffy shall use Your location based information that is
                  captured by Jiffy through the global positioning system (GPS)
                  when You are using Your mobile device to request a Jiffy
                  Service on its m-app. Such location based information shall be
                  used by Jiffy only to facilitate and improve the Jiffy
                  Services being offered to You.
                </li>
                <li className="listed">
                  o. We can’t fulfil any tasks which are immoral or unlawful in
                  nature. Jiffy reserves the right to refuse to perform any
                  tasks on the grounds of such tasks being
                  immoral/unethical/unlawful/banned either by Jiffy’s internal
                  policies or as per the independent discretion of Jiffy. Jiffy
                  may also refuse to perform any task on the grounds that such
                  task is prohibited under any contract to which we are party.
                </li>
                <li className="listed">
                  p. You understand and acknowledge that Jiffy by itself does
                  not provide any delivery services through its own employees,
                  and that Jiffy is not responsible for the quality of such
                  delivery services. Accordingly, in the event of any grievances
                  arising from the transaction initiated by You on the Platform
                  pertaining to delivery services, You may contact Jiffy support
                  for routing Your grievances to the Delivery Partner through
                  the Platform.
                </li>
                <li className="listed">
                  q. You hereby acknowledge that if You have any complaint with
                  respect to the Jiffy Services, You will first inform Jiffy in
                  writing within 24 (twenty four) hours of using such Jiffy
                  Services.
                </li>
                <li className="listed">3. User Information</li>
                <li className="listed">
                  a. You are solely responsible for and in control of the
                  information You provide to us. Compilation of User Accounts
                  and User Account bearing contact number and e-mail addresses
                  are owned by Jiffy. Further, You understand and agree that
                  certain information will be case sensitive and must be handled
                  with prudent care.
                </li>
                <li className="listed">
                  b. In the case where the Platform is unable to establish
                  unique identity of the User against a valid mobile number or
                  e-mail address, the Account shall be indefinitely suspended.
                  Jiffy reserves the full discretion to suspend a User’s Account
                  in the above event and does not have the liability to share
                  any Account information whatsoever.
                </li>
                <li className="listed">4. Payment Terms</li>
                <li className="listed">
                  While initiating a request for a Pick Up and Drop Off Service,
                  You shall pay the service fees for availing the Pick Up and
                  Drop Off Service, as may be displayed to You on the Platform.
                  Only upon making such payment will the Delivery Partner
                  initiate the Pick Up and Drop of Service.
                </li>
                <li className="listed">
                  Service Fees: With respect to Delivery Services, You will be
                  charged a separate service fees (“Service Fees”). The Service
                  Fees shall be paid prior to availing any of the Jiffy
                  Services.
                </li>
                <li className="listed">
                  You agree that Jiffy may use certain third-party vendors and
                  service providers, including payment gateways, to process the
                  payments made by You on the Platform.
                </li>
                <li className="listed">5. Rating</li>
                <li className="listed">
                  a. You agree that: (i) after completion of a transaction on
                  the Platform, the Platform will prompt the User with an option
                  to provide a rating and comments about the Delivery Partner
                  (with respect to the services performed by the Delivery
                  Partner) and (ii) the Delivery Partner may also be prompted to
                  rate You on the Platform. Based upon such Delivery Partner
                  ratings, Your rating score on the Platform will be determined
                  and displayed.
                </li>
                <li className="listed">
                  b. Jiffy and its affiliates reserve the right to use, share
                  and display such ratings and comments in any manner in
                  connection with the business of Jiffy and its affiliates
                  without attribution to or approval of Users and You hereby
                  consent to the same. Jiffy and its affiliates reserve the
                  right to edit or remove comments in the event that such
                  comments include obscenities or other objectionable content,
                  include an individual’s name or other personal information, or
                  violate any privacy laws, other applicable laws or Jiffy’s or
                  its affiliates’ content policies.
                </li>
                <li className="listed">
                  c. Location: You acknowledge and agree that Your geo-location
                  information is required for You to avail the Jiffy Services
                  and initiate transactions on the Platform. You acknowledge and
                  hereby consent to the monitoring and tracking of Your
                  geo-location information. In addition, Jiffy may share Your
                  geo-location information with Delivery Partners.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>PART B – SPECIFIC TERMS FOR JIFFY SERVICES</b>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>6. Cancellation and Refund</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  a. Jiffy shall confirm and initiate the execution of the
                  transaction initiated by You upon receiving confirmation from
                  You for the same. If You wish to cancel a transaction on the
                  Platform, You shall select the cancel option on the Platform.
                  It is to be noted that You may have to pay a cancellation fee
                  for transactions initiated on the Platform for which work has
                  already been commenced by the Delivery Partner.
                </li>
                <li className="listed">
                  b. Jiffy may cancel the transaction initiated by You on the
                  Platform, if: The designated address to avail the Jiffy
                  Services provided by You is outside the service zone of Jiffy.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>Safety guidelines</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  Failure to get your response via phone or any other
                  communication channel at the time of confirmation of the order
                  booking. The transaction involves supply/delivery of any
                  material good that is illegal, offensive or violative of the
                  Terms of Use. Information, instructions and authorisations
                  provided by You is not complete or sufficient to execute the
                  transaction initiated by You on the Platform. If a Delivery
                  Partner is not available to perform the services, as may be
                  requested. If the transaction cannot be completed for reasons
                  not in control of Jiffy. c. You shall only be able to claim
                  refunds for transactions initiated by You only if You have
                  already pre-paid the fees with respect to such transaction.
                  Subject to our refund policy and in accordance therein, You
                  shall be eligible to get the refund in the following
                  circumstances: Your package has been tampered or damaged at
                  the time of delivery, as determined by Jiffy basis the
                  parameters established by Jiffy in its sole discretion. If the
                  wrong Item has been delivered to You, which does not match
                  with the Item for which You had initiated a transaction on the
                  Platform. Jiffy has cancelled the order because of any reason
                  mentioned under Para 6 (b) above. All decisions with respect
                  to refunds will be at the sole discretion of Jiffy and in
                  accordance with Jiffy’s internal refund policy and the same
                  shall be final and binding. All refunds initiated by Jiffy
                  shall be refunded to the financial source account from which
                  You have initiated the transaction on the Platform.
                </li>
                <li className="listed">7. Pick Up and Drop Off Services</li>
                <li className="listed">
                  i. As a part of the Jiffy Services, Jiffy also gives You an
                  option to avail the Pick Up and Drop Off Services being
                  provided by the Delivery Partners.
                </li>
                <li className="listed">
                  ii. You can initiate a transaction on the Platform by which
                  You may (through the help of a Delivery Partner) send packages
                  at a particular location. The Pick Up and Drop Off Services
                  are provided to You directly by the Delivery Partner and Jiffy
                  merely acts as a technology platform to facilitate
                  transactions initiated on the Platform and Jiffy does not
                  assume any responsibility or liability for any form of
                  deficiency of services on part of the Delivery Partner.
                </li>
                <li className="listed">
                  iii. Upon initiation of a request for Pick Up and Drop Off
                  Services on the Platform, depending upon the availability of
                  Delivery Partner around Your area, Jiffy will assign a
                  Delivery Partner to You. The Delivery Partner shall pick up
                  the Item from a location designated by You on the Platform and
                  drop off the Items at a particular location designated by You.
                  While performing the Pick Up and Drop off Services, the
                  Delivery Partner shall act as an agent of You and shall act in
                  accordance with Your instructions. You agree and acknowledge
                  that the pick-up location and the drop off location has been
                  added by You voluntarily and such information will be used for
                  the Jiffy Services and shall be handled by Jiffy in accordance
                  with the terms of its Privacy Policy. iv. You agree that You
                  shall not request for a Pick Up and Drop Off Services for
                  Items which are illegal, hazardous, dangerous, or otherwise
                  restricted or constitute Items that are prohibited by any
                  statute or law or regulation or the provisions of this Terms
                  of Use. v. You agree that before requesting a Pick-up and
                  Drop-off Service, You are well aware of the contents of the
                  package sent or requested by You through registered Delivery
                  Partner, and that such contents are legal and within limits of
                  transportation under any applicable laws. Such contents shall
                  not be restricted and/or banned and/or dangerous and/or
                  prohibited for carriage (such items include, but are not
                  limited to, radio-active, incendiary, corrosive or flammable
                  substances, hazardous chemicals, explosives, firearms or parts
                  thereof and ammunition, firecrackers, cyanides, precipitates,
                  gold and silver ore, bullion, precious metals and stones,
                  jewellery, semi-precious stones including commercial carbons
                  or industrial diamonds, currency (paper or coin) of any
                  nationality, securities (including stocks and bonds, share
                  certificates and blank signed share transfer forms), coupons,
                  stamps, negotiable instruments in bearer form, cashier’s
                  cheques, travellers’ cheques, money orders, passports,
                  credit/debit/ATM cards, antiques, works of art, lottery
                  tickets and gambling devices, livestock, fish, insects,
                  animals, plants and plant material, human corpses, organs or
                  body parts, blood, urine and other liquid diagnostic
                  specimens, hazardous or bio-medical waste, wet ice,
                  pornographic materials, contraband, bottled alcoholic
                  beverages or any intoxicant or narcotics and psychotropic
                  substances or any other prohibited material or material for
                  the transportation of which specific authorisation/license is
                  required under applicable laws).
                </li>
                <li className="listed">
                  vi. You also agree that, upon becoming aware of the commission
                  any offence by You or Your intention to commit any offence
                  upon initiating a Pick-up and Drop-off Service or during a
                  Pick-up and Drop-off service of any Item(s) restricted under
                  applicable law, the Delivery Partner may report such
                  information to Jiffy or to the law enforcement authorities.
                </li>
                <li className="listed">
                  If any User fails to observe the above rules of conduct at any
                  time, Jiffy reserves the right to terminate the User from the
                  Platform, depending on the nature and severity of the breach
                  and without prior warning or consent of the User.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>PART C: GENERAL TERMS OF USE</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              8. Eligibility to Use
              <br />
            </Typography>

            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  a. The Jiffy Services are not available to minors i.e. persons
                  under the age of 18 (eighteen) years or to any Users suspended
                  or removed by Jiffy from accessing the Platform for any reason
                  whatsoever. You represent that You are of legal age to form a
                  binding contract and are not a person barred from receiving/
                  using or availing Jiffy Services under the applicable laws. b.
                  Jiffy reserves the right to refuse access to the Platform, at
                  any time to new Users or to terminate or suspend access
                  granted to existing Users at any time without according any
                  reasons for doing so.
                </li>
                <li className="listed">
                  c. You shall not have more than 1 (one) active Account (as
                  defined below) on the Platform. Additionally, You are
                  prohibited from selling, trading, or otherwise transferring
                  Your Account to another party or impersonating any other
                  person for the purposing of creating an account with the
                  Platform.
                </li>
                <li className="listed">
                  9. User Account, Password, and Security
                </li>
                <li className="listed">
                  a. In order to use the Platform and avail the Jiffy Services,
                  You will have to register on the Platform and create an
                  account with a unique user identity and password (“Account”).
                  If You are using the Platform on a compatible mobile or
                  tablet, You will have to install the application and then
                  proceed with registration.
                </li>
                <li className="listed">
                  b. You will be responsible for maintaining the confidentiality
                  of the Account information, and are fully responsible for all
                  activities that occur under Your Account. You agree to (i)
                  immediately notify Jiffy of any unauthorized use of Your
                  Account information or any other breach of security, and (ii)
                  ensure that You exit from Your Account at the end of each
                  session. Jiffy cannot and will not be liable for any loss or
                  damage arising from Your failure to comply with this
                  provision. You may be held liable for losses incurred by Jiffy
                  or any other User of or visitor to the Platform due to
                  authorized or unauthorized use of Your Account as a result of
                  Your failure in keeping Your Account information secure and
                  confidential.Use of another User’s Account information for
                  using the Platform is expressly prohibited.
                </li>
                <li className="listed">10. Representations and Warranties</li>
                <li className="listed">
                  a. Subject to compliance with the Terms of Use, Jiffy grants
                  You a non-exclusive, limited privilege to access and use this
                  Platform and the Jiffy Services.
                </li>
                <li className="listed">
                  b. You agree to use the Platform only: (i) for purposes that
                  are permitted by this Terms of Use; and (ii) in accordance
                  with any applicable law, regulation or generally accepted
                  practices or guidelines. You agree not to engage in activities
                  that may adversely affect the use of the Platform by Jiffy or
                  Delivery Partner(s) or Merchants or other Users.
                </li>
                <li className="listed">
                  c. You represent and warrant that You have not received any
                  notice from any third party or any governmental authority and
                  no litigation is pending against You in any court of law,
                  which prevents You from accessing the Platform and/or availing
                  the Jiffy Services. d. You represent and warrant that You are
                  legally authorised to view and access the Platform and avail
                  the Jiffy Services.
                </li>
                <li className="listed">
                  e. You agree not to access (or attempt to access) the Platform
                  by any means other than through the interface that is provided
                  by Jiffy. You shall not use any deep-link, robot, spider or
                  other automatic device, program, algorithm or methodology, or
                  any similar or equivalent manual process, to access, acquire,
                  copy or monitor any portion of the Platform, or in any way
                  reproduce or circumvent the navigational structure or
                  presentation of the Platform, materials or any Jiffy Property,
                  to obtain or attempt to obtain any materials, documents or
                  information through any means not specifically made available
                  through the Platform. f. You acknowledge and agree that by
                  accessing or using the Platform, You may be exposed to content
                  from others that You may consider offensive, indecent or
                  otherwise objectionable. Jiffy disclaims all liabilities
                  arising in relation to such offensive content on the Platform.
                </li>
              </ol>
            </Typography>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <b>g. Further, You undertake not to:</b>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li className="listed">
                  defame, abuse, harass, threaten or otherwise violate the legal
                  rights of others; publish, post, upload, distribute or
                  disseminate any inappropriate, profane, defamatory,
                  infringing, disparaging, ethnically objectionable, obscene,
                  indecent or unlawful topic, name, material or information; do
                  any such thing that may harms minors in any way; copy,
                  republish, post, display, translate, transmit, reproduce or
                  distribute any Jiffy Property through any medium without
                  obtaining the necessary authorization from Jiffy; conduct or
                  forward surveys, contests, pyramid schemes or chain letters;
                  upload or distribute files that contain software or other
                  material protected by applicable intellectual property laws
                  unless You own or control the rights thereto or have received
                  all necessary consents; upload or distribute files or
                  documents or videos (whether live or pre-recorded) that
                  contain viruses, corrupted files, or any other similar
                  software or programs that may damage the operation of the
                  Platform or another’s computer; engage in any activity that
                  interferes with or disrupts access to the Platform (or the
                  servers and networks which are connected to the Platform);
                  attempt to gain unauthorized access to any portion or feature
                  of the Platform, any other systems or networks connected to
                  the Platform, to any Jiffy server, or through the Platform, by
                  hacking, password mining or any other illegitimate means;
                  probe, scan or test the vulnerability of the Platform or any
                  network connected to the Platform, nor breach the security or
                  authentication measures on the Platform or any network
                  connected to the Platform. You may not reverse look-up, trace
                  or seek to trace any information on any other User, of or
                  visitor to, the Platform, to its source, or exploit the
                  Platform or information made available or offered by or
                  through the Platform, in any way whether or not the purpose is
                  to reveal any information, including but not limited to
                  personal identification information, other than Your own
                  information, as provided on the Platform; disrupt or interfere
                  with the security of, or otherwise cause harm to, the
                  Platform, systems resources, accounts, passwords, servers or
                  networks connected to or accessible through the Platform or
                  any affiliated or linked sites; collect or store data about
                  other Users, Merchants, Delivery Partner in connection with
                  the prohibited conduct and activities set forth herein; use
                  any device or software to interfere or attempt to interfere
                  with the proper working of the Platform or any transaction
                  being conducted on the Platform, or with any other person’s
                  use of the Platform; use the Platform or any material or Jiffy
                  Property for any purpose that is unlawful or prohibited by
                  these Terms of Use, or to solicit the performance of any
                  illegal activity or other activity which infringes the rights
                  of the Company or other third parties; falsify or delete any
                  author attributions, legal or other proper notices or
                  proprietary designations or labels of the origin or source of
                  software or other material contained in a file that is
                  uploaded; impersonate any other User, Merchant, Delivery
                  Partner or person; violate any applicable laws or regulations
                  for the time being in force within or outside India or
                  anyone’s right to privacy or personality; violate the Terms of
                  Use contained herein or elsewhere; reverse engineer, modify,
                  copy, distribute, transmit, display, perform, reproduce,
                  publish, license, create derivative works from, transfer, or
                  sell any information or software obtained from the Platform.
                </li>
                <li className="listed">
                  h. You agree and acknowledge that the use of the Jiffy
                  Services offered by Jiffy is at Your sole risk and that Jiffy
                  disclaims all representations and warranties of any kind,
                  whether express or implied as to condition, suitability,
                  quality, merchantability and fitness for any purposes are
                  excluded to the fullest extent permitted by law.
                </li>
                <li className="listed">
                  i. Without prejudice to the above, Jiffy makes no
                  representation or warranty that the Jiffy Services will meet
                  Your requirements.
                </li>
                <li className="listed">
                  j. All materials/content on our Platform (except any third
                  party content available on the Platform), including, without
                  limitation, names, logos, trademarks, images, text, columns,
                  graphics, videos, photographs, illustrations, artwork,
                  software and other elements (collectively, “Material”) are
                  protected by copyrights, trademarks and/or other intellectual
                  property rights owned and controlled by Jiffy. You acknowledge
                  and agree that the Material is made available for limited,
                  non-commercial, personal use only. Except as specifically
                  provided herein or elsewhere in our Platform, no Material may
                  be copied, reproduced, republished, sold, downloaded, posted,
                  transmitted, or distributed in any way, or otherwise used for
                  any purpose other than the purposes stated under this Terms of
                  Use, by any person or entity, without Jiffy’s prior express
                  written permission. You may not add, delete, distort, or
                  otherwise modify the Material. Any unauthorized attempt to
                  modify any Material, to defeat or circumvent any security
                  features, or to utilize our Platform or any part of the
                  Material for any purpose other than its intended purposes is
                  strictly prohibited. Subject to the above restrictions under
                  this Clause, Jiffy hereby grants You a non-exclusive, freely
                  revocable (upon notice from Jiffy), non-transferable access to
                  view the Material on the Platform.
                </li>
                <li className="listed">11. Intellectual Property Rights</li>
                <li className="listed">
                  a. The Platform and process, and their selection and
                  arrangement, including but not limited to, all text, videos,
                  graphics, user interfaces, visual interfaces, sounds and music
                  (if any), artwork, algorithm and computer code (and any
                  combination thereof), except any third party software
                  available on the Platform, is owned by Jiffy (“Jiffy
                  Property”) and the design, structure, selection,
                  co-ordination, expression, look and feel and arrangement of
                  such Jiffy Property is protected by copyright, patent and
                  trademark laws, and various other intellectual property
                  rights. You are not permitted to use Jiffy Property without
                  the prior written consent of Jiffy.
                </li>
                <li className="listed">
                  b. The trademarks, logos and service marks displayed on the
                  Platform (“Marks”) are the property of Jiffy, except any
                  trademark, logos and service marks of third parties available
                  on the Platform. You are not permitted to use the Marks
                  without the prior consent of Jiffy or such third party as may
                  be applicable.
                </li>
                <li className="listed">
                  12. Disclaimer of Warranties & Liabilities
                </li>
                <li className="listed">
                  You expressly understand and agree that, to the maximum extent
                  permitted by applicable law:
                </li>
                <li className="listed">
                  a. The Platform and Jiffy Property, Jiffy Services are
                  provided by Jiffy on an “as is” basis without warranty of any
                  kind, express, implied, statutory or otherwise, including the
                  implied warranties of title, non-infringement, merchantability
                  or fitness for a particular purpose. Without limiting the
                  foregoing, Jiffy makes no warranty that (i) the Platform,
                  Jiffy Services will meet Your requirements or Your use of the
                  Platform will be uninterrupted, timely, secure or error-free;
                  (ii) the quality of the Platform will meet Your expectations;
                  or (iii) any errors or defects in the Platform will be
                  corrected. No advice or information, whether oral or written,
                  obtained by You from Jiffy shall create any warranty not
                  expressly stated in the Terms of Use.
                </li>
                <li className="listed">
                  b. Jiffy will have no liability related to any User content
                  arising under intellectual property rights, libel, privacy,
                  publicity, obscenity or other laws. Jiffy also disclaims all
                  liability with respect to the misuse, loss, modification or
                  unavailability of any User content.
                </li>
                <li className="listed">
                  c. Jiffy will not be liable for any loss that You may incur as
                  a consequence of unauthorized use of Your Account or Account
                  information in connection with the Platform either with or
                  without Your knowledge.
                </li>
                <li className="listed">
                  d. Jiffy shall not be responsible for the delay or inability
                  to use the Platform, Jiffy Services or related
                  functionalities, the provision of or failure to provide
                  functionalities, or for any information, software,
                  functionalities and related graphics obtained through the
                  Platform, or otherwise arising out of the use of the Platform,
                  whether based on contract, tort, negligence, strict liability
                  or otherwise. Further, Jiffy shall not be held responsible for
                  non-availability of the Platform during periodic maintenance
                  operations or any unplanned suspension of access to the
                  Platform that may occur due to technical reasons or for any
                  reason beyond Jiffy’s control. You understand and agree that
                  any material or data downloaded or otherwise obtained through
                  the Platform is done entirely at Your own discretion and risk,
                  and that You will be solely responsible for any damage to Your
                  computer systems or loss of data that results from the
                  download of such material or data.
                </li>
                <li className="listed">
                  13. Indemnification and Limitation of Liability
                </li>
                <li className="listed">
                  a. You agree to indemnify, defend and hold harmless Jiffy and
                  its affiliates including but not limited to its officers,
                  directors, consultants, agents and employees (“Indemnitees”)
                  from and against any and all losses, liabilities, claims,
                  damages, demands, costs and expenses (including legal fees and
                  disbursements in connection therewith and interest chargeable
                  thereon) asserted against or incurred by the Indemnitees that
                  arise out of, result from, or may be payable by virtue of, any
                  breach or non-performance of any obligation, covenant,
                  representation or warranty by You pursuant to these Terms of
                  Use. Further, You agree to hold the Indemnitees harmless
                  against any claims made by any third party due to, or arising
                  out of, or in connection with, Your use of the Platform, Jiffy
                  Services, any misrepresentation with respect to the data or
                  information provided by You in relation to the Account, Your
                  violation of the Terms of Use, or Your violation of any rights
                  of another, including any intellectual property rights.
                </li>
                <li className="listed">
                  b. In no event shall the Indemnitees be liable to You or any
                  third party for any special, incidental, indirect,
                  consequential or punitive damages whatsoever, arising out of
                  or in connection with Your use of or access to the Platform or
                  Jiffy Property on the Platform.
                </li>
                <li className="listed">
                  c. Your indemnification obligation under the Terms of Use will
                  survive the termination of Your Account or use of the Platform
                  or Jiffy Services.
                </li>
                <li className="listed">
                  d. Subject to applicable laws, in no event will Jiffy or its
                  employees aggregate liability, arising from or related to the
                  Jiffy Services or the use of the Platform exceeding AED 100
                  for any and all causes of actions brought by You or on behalf
                  of You.
                </li>
                <li className="listed">
                  e. The Platform and the Jiffy Services are only available to
                  Users located in Dubai. Users shall not access or use the
                  Platform from any other jurisdiction except for Dubai. If a
                  User accesses or uses the Platform from any other jurisdiction
                  except for Dubai, the User shall be liable to comply with all
                  applicable laws and Jiffy shall not be liable for the same,
                  whatsoever.
                </li>
                <li className="listed">14. Violation of the Terms of Use</li>
                <li className="listed">
                  You agree that any violation by You of these Terms of Use will
                  constitute an unlawful and unfair business practice, and will
                  cause irreparable harm to Jiffy, for which monetary damages
                  would be inadequate, and You consent to Jiffy obtaining any
                  injunctive or equitable relief that they deem necessary or
                  appropriate in such circumstances. These remedies are in
                  addition to any other remedies that Jiffy may have at law or
                  in equity. If Jiffy takes any legal action against You as a
                  result of Your violation of these Terms of Use, they will be
                  entitled to recover from You, and You agree to pay all
                  reasonable attorneys’ fees and costs of such action, in
                  addition to any other relief that may be granted.
                </li>
                <li className="listed">15. Additional Terms</li>
                <li className="listed">
                  a. We may also require You to follow additional rules,
                  guidelines or other conditions in order to participate in
                  certain promotions or activities available through the
                  Platform. These additional terms shall form a part of this
                  Terms of Use, and You agree to comply with them when You
                  participate in those promotions, or otherwise engage in
                  activities governed by such additional terms.
                </li>
                <li className="listed">16. Link to Third Parties</li>
                <li className="listed">
                  a. The Platform may contain links to other sites owned by
                  third parties (i.e. advertisers, affiliate partners, strategic
                  partners, or others). Jiffy shall not be responsible for
                  examining or evaluating such third party websites, and Jiffy
                  does not warrant the products or offerings of, any of these
                  businesses or individuals, or the accuracy of the content of
                  such third party websites. Jiffy does not assume any
                  responsibility or liability for the actions, product, and
                  content of any such third party websites. Before You
                  use/access any such third-party websites, You should review
                  the applicable terms of use and policies for such third party
                  websites. If You decide to access any such linked third party
                  website, You do so at Your own risk.
                </li>
                <li className="listed">17. Term and Termination</li>
                <li className="listed">
                  a. The Terms of Use will continue to apply until terminated by
                  either You or Jiffy as set forth below. If You object to the
                  Terms of Use or are dissatisfied with the Platform, Jiffy
                  Services, Your only recourse is to (i) close Your Account on
                  the Platform by writing to Us at Office suite # 207, Misa Business Centre, Blue Wave Tower, Wadi Al Safa 5, 
                  Dubai - UAE,
                  Email: support@jiffy.ae; and/or (ii) stop accessing the
                  Platform. Jiffy will make Your account dormant upon receipt of
                  request in writing. Jiffy may, in its sole discretion, bar
                  your use of the Jiffy Services at any time, for any or no
                  reason. Even after your account with Jiffy is disabled,
                  dormant or made inactive, the terms agreed by You at the time
                  of registration will remain in effect. This termination shall
                  be effective only once You have cleared all Your dues that You
                  are liable to pay as per the provisions of this Terms of Use.
                  b. The Company may delist You or block Your future access to
                  the Platform or suspend or terminate Your Account if it
                  believes, in its sole and absolute discretion that You have
                  infringed, breached, violated, abused, or unethically
                  manipulated or exploited any term of these Terms of Use or
                  anyway otherwise acted unethically. c. Notwithstanding
                  anything in this clause, these Terms of Use will survive
                  indefinitely unless and until Jiffy chooses to terminate them.
                </li>
                <li className="listed">
                  d. You hereby agree and acknowledge, upon termination, Jiffy
                  shall have the right to retain all information pertaining to
                  the transactions initiated by You on the Platform.
                </li>
                <li className="listed">
                  18. Governing Law and Dispute Resolution
                </li>
                <li className="listed">
                  These Terms of Use shall be governed by and construed in
                  accordance with the laws of India and subject to the
                  provisions of arbitration set out herein, the courts at
                  Bangalore, India shall have exclusive jurisdiction in relation
                  to any Disputes (defined below) arising out of or in
                  connection with this these Terms of Use. Any adverse action,
                  dispute or difference arising under or relating to these Terms
                  of Use (“Dispute”) shall at the first instance be resolved
                  through good faith negotiations between the parties hereto,
                  which negotiations shall begin promptly, within 15 (fifteen)
                  days after a party has delivered to the other party a written
                  request for such negotiations. If the parties are unable to
                  resolve the Dispute in question within 15 (fifteen) days of
                  the commencement of such negotiations, the Dispute shall be
                  referred to and finally resolved by arbitration in accordance
                  with the Indian Arbitration and Conciliation Act, 1996, as
                  amended from time to time and rules prescribed thereunder.
                  When any Dispute is under arbitration, except for the matters
                  under dispute, We and you shall continue to exercise the
                  remaining respective rights and fulfil the remaining
                  respective obligations under these Terms of Use. The
                  arbitration shall be conducted by a sole arbitrator appointed
                  by Jiffy and the seat of arbitration shall be Bangalore,
                  India. The language of the arbitration proceedings and of all
                  written decisions and correspondence relating to the
                  arbitration shall be English.
                </li>
                <li className="listed">19. Report Abuse</li>
                <li className="listed">
                  In the event You come across any abuse or violation of these
                  Terms of Use or if You become aware of any objectionable
                  content on the Platform, please report the same to the
                  following e-mail id: support@jiffy.ae. In case You have any
                  queries with respect to the Terms or the Jiffy Services,
                  please write to Us at Office suite # 207, Misa Business Centre, Blue Wave Tower, Wadi Al Safa 5, 
                  Dubai - UAE.
                </li>

                <li className="listed">20. Communications</li>
                <li className="listed">
                  You hereby expressly agree to receive communications by way of
                  SMSs and/or e-mails and/or Whatsapp from Jiffy, or other third
                  parties. You can unsubscribe/ opt-out from receiving
                  communications through SMS, Whatsapp and email anytime by
                  contacting us for the same. However, You may still receive
                  communications from Your end with respect to Your use of the
                  Jiffy Service.
                </li>
                <li className="listed">21. General</li>
                <li className="listed">
                  a. Amendments: Jiffy reserves the unconditional right to
                  modify or amend this Terms of Use without any requirement to
                  notify You of the same. You can determine when this Terms of
                  Use was last modified by referring to the “Last Updated”
                  legend above. It shall be Your responsibility to check this
                  Terms of Use periodically for changes. Your acceptance of the
                  amended Terms of Use shall signify Your consent to such
                  changes and agreement to be legally bound by the same. b.
                  Notice: All notices from Jiffy will be served by email to Your
                  registered email address or by general notification on the
                  Platform. c. Assignment: You cannot assign or otherwise
                  transfer the Terms of Use, or any rights granted hereunder to
                  any third party. Jiffy’s rights under the Terms of Use are
                  freely transferable by Jiffy to any third party without the
                  requirement of informing You or seeking Your consent. d.
                  Severability: If, for any reason, a court of competent
                  jurisdiction finds any provision of the Terms of Use, or any
                  portion thereof, to be unenforceable, that provision shall be
                  enforced to the maximum extent permissible so as to give
                  effect to the intent of the parties as reflected by that
                  provision, and the remainder of the Terms of Use shall
                  continue in full force and effect. e. Waiver: Any failure by
                  Jiffy to enforce or exercise any provision of the Terms of
                  Use, or any related right, shall not constitute a waiver by
                  Jiffy of that provision or right. f. Integration: These Terms
                  of Use together with Jiffy’s Privacy Policy and any other
                  legal notices, communications published by Jiffy on its
                  Platform, and any other agreements executed between You and
                  Jiffy shall constitute the entire agreement between you and
                  Jiffy concerning its Platform, Jiffy Services and governs Your
                  use of the Platform and Jiffy Service, superseding any prior
                  agreements between You and Jiffy with respect to the Platform
                  and Jiffy Service g. IP Infringement: If You believe the
                  Platform violates Your intellectual property, You must
                  promptly notify Jiffy in writing at Office suite # 207, Misa Business Centre, Blue Wave Tower, Wadi Al Safa 5, 
                  Dubai - UAE, Email: support@jiffy.ae. These notifications should only
                  be submitted by the owner of the intellectual property or an
                  agent duly authorized to act on his/her behalf. However, any
                  false claim by You may result in the termination of Your
                  access to the Platform. You are required to provide the
                  following details in Your notice:
                </li>
                <li className="listed">
                  i. the intellectual property that You believe is being
                  infringed;
                </li>
                <li className="listed">
                  ii. the item that You think is infringing and include
                  sufficient information about where the material is located on
                  the Platform;
                </li>
                <li className="listed">
                  iii. a statement that You believe in good faith that the item
                  You have identified as infringing is not authorized by the
                  intellectual property owner, its agent, or the law to be used
                  in connection with the Platform;
                </li>
                <li className="listed">
                  iv. Your contact details, such as Your address, telephone
                  number, and/or email;
                </li>
                <li className="listed">
                  v. a statement that the information You provided in Your
                  notice is accurate, and that You are the intellectual property
                  owner or an agent authorized to act on behalf of the
                  intellectual property owner whose intellectual property is
                  being infringed; and
                </li>
                <li className="listed">
                  vi. Your physical or electronic signature.
                </li>
              </ol>
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
export default withStyles(SendPackageStyle)(PhotoService);
